<template>
    <b-list-group class="bodyguard-service-view">
        <b-list-group-item variant="orange">
            <b-row>
                <b-col cols="12"><strong>Servicio en Curso</strong></b-col>
            </b-row>
        </b-list-group-item>
        <b-list-group-item>
            <b-row>
                <b-col cols="6"><strong>Tipo de servicio</strong></b-col>
                <b-col cols="6">{{ bodyguardService.type }}</b-col>
            </b-row>
        </b-list-group-item>
        <b-list-group-item>
            <b-row>
                <b-col cols="6"><strong>Fecha de inicio</strong></b-col>
                <b-col cols="6">{{ bodyguardService.start_date | datetime }}</b-col>
            </b-row>
        </b-list-group-item>
        
        <b-list-group-item>
            <b-row>
                <b-col cols="6"><strong>{{ bodyguardService.type === 'vehicular'? 'Placa vehículo': 'Documento persona' }}</strong></b-col>
                <b-col cols="6">{{ bodyguardService.plate_document }}</b-col>
            </b-row>
        </b-list-group-item>
        <b-list-group-item>
            <b-row>
                <b-col cols="6"><strong>{{ bodyguardService.type === 'vehicular'? 'Nombre conductor': 'Nombre persona' }}</strong></b-col>
                <b-col cols="6">{{ bodyguardService.driver_person_name }}</b-col>
            </b-row>
        </b-list-group-item>
        <b-list-group-item>
            <b-row>
                <b-col cols="6"><strong>Ciudad</strong></b-col>
                <b-col cols="6">{{ !!bodyguardService.city? bodyguardService.city.name: '' }}</b-col>
            </b-row>
        </b-list-group-item>
        <b-list-group-item>
            <b-row>
                <b-col cols="6">
                    <strong>Fuera de la ciudad</strong>
                </b-col>
                <b-col cols="6">
                    {{ bodyguardService.out_of_city | yesno }}
                </b-col>
            </b-row>
        </b-list-group-item>
        <b-list-group-item v-if="!!bodyguardService.town">
            <b-row>
                <b-col cols="6">
                    <strong>Lugar</strong>
                </b-col>
                <b-col cols="6">
                    {{ bodyguardService.town.name }}
                </b-col>
            </b-row>
        </b-list-group-item>
    </b-list-group>
</template>
<script>
export default {
    name: 'bodyguard_service_view',
    props: {
        bodyguardService: {
            type: Object,
            required: true
        }
    }
}
</script>
<style scoped>
.bodyguard-service-view {
    font-size: 0.8rem;
}
</style>
